import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { updatePricing } from "../../../../services/profile";
import { toast } from "react-toastify";
import { setLoading } from "../../../../reducer/auth/auth";

export default function Professional(props) {
  const dispatch = useDispatch();
  const {
    stepOneData,
    id,
    onProfileUpdate
  } = props;
  const {
    session_length_30,
    session_length_45,
    session_length_60,
    session_length_45_2,
    session_length_60_2,
    session_currency,
  } = stepOneData || {};
  useEffect(() => {
    

  }, []);
  const updateSessionLength = (formData) => {
    dispatch(setLoading(true));
    const {
      session_length_30,
      session_length_45,
      session_length_60,
      session_length_60_2,
      session_length_45_2,
      session_currency
    } = formData;
    let item = {
      userId: id,
      session_length: JSON.stringify({
        30: session_length_30,
        45: session_length_45,
        60: session_length_60,
        452: session_length_45_2,
        602: session_length_60_2,
      }),
      session_currency: JSON.stringify({
        30: session_currency,
        45: session_currency,
        60: session_currency,
        452: session_currency,
        602: session_currency,
      }),
    };
    updatePricing(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          stepOneData.session_currency = session_currency
          toast.success("Session Price Updated", { position: "top-center" });
          if (typeof onProfileUpdate === 'function') {
            onProfileUpdate(); // Call the parent function
          } else {
            console.error('onProfileUpdate is not a function');
          }
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  }
  return (
    <div className="pricing-card">
      <Formik
        initialValues={{
          session_length_30: session_length_30 || '', // Provide default value if stepOneData doesn't have this key
          session_length_45: session_length_45 || '',
          session_length_60: session_length_60 || '',
          session_length_45_2: session_length_45_2 || '',
          session_length_60_2: session_length_60_2 || '',
          session_currency: session_currency || ''
        }}

        onSubmit={(values, actions) => {
          // Validate form fields
          let errors = {};
          //   if (values.session_length_30 === '') {
          //     errors.session_length_30 = 'This field is required';
          //   }
          //   if (values.session_length_45 === '') {
          //     errors.session_length_45 = 'This field is required';
          //   }
          //   if (values.session_length_60 === '') {
          //     errors.session_length_60 = 'This field is required';
          //   }
          //   if (values.session_length_45_2 === '') {
          //     errors.session_length_45_2 = 'This field is required';
          //   }
          //   if (values.session_length_60_2 === '') {
          //     errors.session_length_60_2 = 'This field is required';
          //   }

          actions.setErrors(errors);

          // Check if there are any errors
          if (Object.keys(errors).length === 0) {
            // Handle form submission here
            updateSessionLength(values);
            actions.setSubmitting(false);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
        }) => (
          <Form>
            <div className="pricing-card-intro">
              <p className="pricing-card-desc">Please enter pricing as per the session length below.</p>
              <div className="pricing-note-box">
                <p className="pricing-note-text">Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.</p>
              </div>
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="session_length_30">30 Minutes</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="session_length_30"
                  name="session_length_30"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_30" component="div" className="error" />
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="session_length_45">45 Minutes</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="session_length_45"
                  name="session_length_45"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_45" component="div" className="error" />
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="session_length_60">60 Minutes</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="session_length_60"
                  name="session_length_60"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_60" component="div" className="error" />
            </div>

            <div className="pricing-row">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="session_length_45_2">45 Minutes for 2 People</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="session_length_45_2"
                  name="session_length_45_2"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_45_2" component="div" className="error" />
            </div>

            <div className="pricing-row pricing-row-last-amount">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label htmlFor="session_length_60_2">60 Minutes for 2 People</label>
              </div>
              <div className="pricing-amount-box">
                <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                <Field
                  className="amount_input pricing-amount-input"
                  id="session_length_60_2"
                  name="session_length_60_2"
                  type="number"
                  placeholder="0.00"
                />
              </div>
              <ErrorMessage name="session_length_60_2" component="div" className="error" />
            </div>

            <div className="pricing-row pricing-row-currency">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label>Session Currency</label>
              </div>
              <div className="pricing-currency-group">
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_usd"
                    value={"USD"}
                    checked={values.session_currency === "USD" ? true : false}
                  />
                  <label htmlFor="session_currency_usd">USD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_cad"
                    value={"CAD"}
                    checked={values.session_currency === "CAD" ? true : false}
                  />
                  <label htmlFor="session_currency_cad">CAD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_aud"
                    value={"AUD"}
                    checked={values.session_currency === "AUD" ? true : false}
                  />
                  <label htmlFor="session_currency_aud">AUD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_eur"
                    value={"EUR"}
                    checked={values.session_currency === "EUR" ? true : false}
                  />
                  <label htmlFor="session_currency_eur">EUR</label>
                </span>
              </div>
            </div>

            <div className="pricing-note-box pricing-note-box-footer">
              <p className="pricing-note-text">Please ensure that your selected payment provider (e.g., PayPal, Square, Stripe) aligns with the session currency you've chosen in VerySoul.</p>
            </div>
            <span className="error text-left">
              {errors.session_currency &&
                touched.session_currency &&
                errors.session_currency}
            </span>

            <div className="pricing-card-footer">
              <button type="submit" className="resend-btn pricing-update-btn">Update</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};